import { render, staticRenderFns } from "./ProductOrderTotal.vue?vue&type=template&id=16ad6016&scoped=true&"
import script from "./ProductOrderTotal.vue?vue&type=script&lang=js&"
export * from "./ProductOrderTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad6016",
  null
  
)

export default component.exports